import React from 'react';
import { useRouter } from 'next/router';
import { Pagination } from 'react-bootstrap';
import Link from 'next/link';

// import styles from './styles'
interface Meta {
  page: number;
  prevPage?: number;
  nextPage?: number;
  resultsPerPage?: number,
  resultsSize: number;
  totalPages: number;
}

interface PaginatorProps {
  // add paginator props here
  meta: Meta;
  hrefBase: string;
}

const Paginator: React.FC<PaginatorProps> = ({
  meta,
  hrefBase,
}: PaginatorProps) => {
  const router = useRouter();

  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(meta.totalPages); i++) {
    pageNumbers.push(i);
  }

  return (
    <Pagination
      className='paginator-nav'
      style={{
        listStyle: 'none',
        display: 'flex',
        justifyContent: 'space-evenly',
        width: '100%',
        margin: '0 auto',
        padding: '2.5rem 0',
      }}
    >
      <Link href={`${hrefBase}1`} passHref>
        <Pagination.First disabled={meta.page === 1 ? true : false} />
      </Link>

      <Link href={`${hrefBase}${meta.page - 1}`} passHref>
        <Pagination.Prev disabled={meta.page === 1 ? true : false} />
      </Link>

      {/* <Pagination.Ellipsis
        onClick={() =>
          paginate(
            meta.page <= 5 || pageNumbers.length <= 5
              ? meta.page
              : meta.page - 5
          )
        }
        disabled={meta.page <= 5 ? true : false}
      /> */}

      {pageNumbers.map((number) => (
        <Pagination.Item
          key={number}
          active={meta.page === number}
          onClick={() => router.push(`${hrefBase}${number}`)}
        >
          {number}
        </Pagination.Item>
      ))}

      {/* <Pagination.Ellipsis
        onClick={() =>
          paginate(
            meta.page >= pageNumbers.length - 5 || pageNumbers.length <= 5
              ? pageNumbers.length
              : meta.page + 5
          )
        }
        disabled={meta.page >= pageNumbers.length - 4 ? true : false}
      /> */}

      <Link href={`${hrefBase}${meta.page + 1}`} passHref>
        <Pagination.Next
          disabled={meta.page === meta.totalPages ? true : false}
        />
      </Link>

      <Pagination.Last
        href={`${hrefBase}${meta.totalPages}`}
        disabled={meta.page === meta.totalPages ? true : false}
      />
    </Pagination>
  );
};

export default Paginator;
